module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n    <div class="m-modal-column"></div>\n\n\n   \n    <div class="m-modal-section" >\n        <div class="m-modal-section__title">Real-time controls</div>\n        ';
 if (hasControlButtons()) { 
__p+='\n        <div class="m-modal-row">\n            <div class="form-group">\n                <label for="name">Device controls</label>\n                <div class="realtime-controls">\n                    ';
 _.each(getControlButtons(), function(button){ 
__p+='\n                        <a class="m-btn js-control-button" role="button" data-command="'+
((__t=( button.command ))==null?'':__t)+
'" data-value="'+
((__t=( button.value ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n                        ';
 }); 
__p+='\n                </div>\n            </div>\n        </div>\n        ';
 } 
__p+='\n        <div class="m-modal-row">\n            <div class="form-group">\n                <label for="name">Change DIM level</label>\n                <div class="realtime-controls">\n                  ';
 _.each(getDimLevels(), function(value){ 
__p+='\n                    <a class="m-btn js-dimlevel" data-dimlevel="'+
((__t=( value ))==null?'':__t)+
'">'+
((__t=( value ))==null?'':__t)+
'%</a>\n                  ';
 }); 
__p+='\n                </div>\n            </div>\n        </div>\n        \n\n\n    </div>\n\n    <div class="m-modal-section" >\n        <div class="m-modal-section__title">Select a preset</div>\n        <div class="m-modal-column">\n            <div class="form-group">\n                <select class="form-control js-preset-select" name="type">\n                    <option value="">Choose...</option>\n                    ';
 _.each(getPresetList(), function(value){ 
__p+='\n                       <option value="'+
((__t=( value._id ))==null?'':__t)+
'" >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                    ';
 }); 
__p+='\n                </select>\n            </div>\n        </div>\n   </div>\n\n\n    <div class="m-modal-section no-bottom-padding" >\n        <div class="m-modal-section__title">Daily routine composer</div>\n    </div>\n\n    <div class="routine__region"></div>\n\n    <div class="m-modal-section__full m-day-routine" >\n        <div class="m-routine-composer js-routine-composer"></div>\n    </div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/control/templates/control-ird.html
// module id = 432
// module chunks = 0